import { render, staticRenderFns } from "./ReleaseConcept.vue?vue&type=template&id=1dd9a23f&scoped=true&"
import script from "./ReleaseConcept.vue?vue&type=script&lang=js&"
export * from "./ReleaseConcept.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseConcept.vue?vue&type=style&index=0&id=1dd9a23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9a23f",
  null
  
)

export default component.exports